import { invokeRPC } from './socket.js'

export function fetchFilteredArticles(rssFeed, dateRange) {
  return invokeRPC('newsTools', 'fetchFilteredArticles', { rssFeed, dateRange });
}